import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNews } from '../features/news/newsSlice';
import NewsCard from '../components/NewsCard';
import NewsCardSkeleton from '../components/NewsCardSkeleton';

const News = ({ category }) => {
  const dispatch = useDispatch();
  const { news, isLoading } = useSelector((state) => state.news);
  const [currentPage, setCurrentPage] = useState(1);
  const newsPerPage = 6;

  useEffect(() => {
    dispatch(getNews(category));
  }, [dispatch, category]);

  useEffect(() => {
    setCurrentPage(1);
  }, [category]);

  // Filter news by category
  const filteredNews = category
    ? news.filter(item => item.category.toLowerCase() === category.toLowerCase().replace(/-/g, ' '))
    : news;

  // Pagination
  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = filteredNews.slice(indexOfFirstNews, indexOfLastNews);
  const totalPages = Math.ceil(filteredNews.length / newsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const getPageTitle = () => {
    if (category) {
      const formattedCategory = category.replace(/-/g, ' ');
      return `Berita ${formattedCategory.charAt(0).toUpperCase() + formattedCategory.slice(1)}`;
    }
    return 'Semua Berita';
  };

  const getPageDescription = () => {
    if (category) {
      const formattedCategory = category.replace(/-/g, ' ');
      return `Informasi dan kegiatan ${formattedCategory}`;
    }
    return 'Semua berita dan kegiatan Penerbit Polbis Press';
  };

  return (
    <div className="py-12">
      <section className="container mx-auto px-4">
        <div className="mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{getPageTitle()}</h1>
          <p className="text-gray-500">{getPageDescription()}</p>
        </div>

        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array(6).fill(0).map((_, index) => <NewsCardSkeleton key={index} />)}
          </div>
        ) : filteredNews.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {currentNews.map(item => (
                <NewsCard key={item._id} news={item} />
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex justify-center items-center gap-2 mt-12">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-4 py-2 border border-gray-200 rounded-xl hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Sebelumnya
                </button>
                {pageNumbers.map(number => (
                  <button
                    key={number}
                    onClick={() => setCurrentPage(number)}
                    className={`px-4 py-2 rounded-xl font-medium transition-colors ${
                      currentPage === number
                        ? 'bg-dark-blue-700 text-white'
                        : 'border border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    {number}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 border border-gray-200 rounded-xl hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  Selanjutnya
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-20">
            <div className="w-20 h-20 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2">Belum ada berita</h3>
            <p className="text-gray-500">Berita akan segera ditampilkan</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default News;
